import React, { useState } from 'react';
import { useRecordContext, useDataProvider } from 'react-admin';

interface AudioPreviewFieldProps {
  source: string;
  label?: string;
}

export const AudioPreviewField = ({ source, label }: AudioPreviewFieldProps) => {
  const record = useRecordContext();
  const dataProvider = useDataProvider();
  const [audioUrl, setAudioUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [hasLoaded, setHasLoaded] = useState(false);

  const handleLoadAudio = async () => {
    if (hasLoaded && audioUrl) return; // Already loaded
    
    if (record && record[source]) {
      setLoading(true);
      setError(null);
      
      try {
        const url = await dataProvider.getAudioUrl(record[source]);
        setAudioUrl(url);
        setHasLoaded(true);
      } catch (err: any) {
        setError('Failed to load audio');
      } finally {
        setLoading(false);
      }
    }
  };

  if (loading) {
    return <span>Loading...</span>;
  }

  if (error) {
    return <span>No audio</span>;
  }

  if (!hasLoaded) {
    return (
      <button 
        onClick={handleLoadAudio}
        style={{ 
          padding: '8px 16px', 
          backgroundColor: '#1976d2', 
          color: 'white', 
          border: 'none', 
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        Load Audio
      </button>
    );
  }

  return (
    <audio 
      controls 
      style={{ width: '200px', height: '40px' }}
      preload="none"
    >
      {audioUrl && (
        <>
          <source src={audioUrl} type="audio/mpeg" />
          <source src={audioUrl} type="audio/mp4" />
          <source src={audioUrl} type="audio/m4a" />
        </>
      )}
      Your browser does not support the audio element.
    </audio>
  );
};

